<div class="dialog-headline" fxLayout="row wrap" fxLayoutAlign="space-between center">
    <h2 mat-dialog-title translate>add_agrement</h2>
    <button mat-dialog-close mat-icon-button>
        <mat-icon>close</mat-icon>
    </button>
</div>

<div mat-dialog-content>


    <div fxFlex="100" fxFlex.lt-md="100">
        <mat-card appCard class="table-card">
            <mat-card-content>

                <table [dataSource]="dataSource" mat-table style="width: 100%">

                    <ng-container
                            *ngFor="let column of displayedColumns"
                            [matColumnDef]="column"
                    >
                        <th *matHeaderCellDef mat-header-cell>
                            {{ labels[column] | translate }}
                        </th>

                        <td *matCellDef="let type" mat-cell>
                            {{ type[column] | typedValue | async | translate }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="N">
                        <th *matHeaderCellDef mat-header-cell width="5%">
                            {{ "N°" | translate }}
                        </th>
                        <td *matCellDef="let element; let i = index;" mat-cell style="cursor: pointer">
                            {{i + 1}}
                        </td>
                    </ng-container>
                    <!--    <ng-container matColumnDef="licenseNm">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ "Code de la classification des produits" | translate }}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.licenseNm}}
                            </td>
                        </ng-container>-->


                    <tr *matHeaderRowDef="displayedColumnss" mat-header-row></tr>
                    <tr *matRowDef="let row; columns: displayedColumnss" mat-row></tr>

                </table>
                <app-empty-list-container [list]="Ussine" [withoutBorder]="true"></app-empty-list-container>
            </mat-card-content>


        </mat-card>

    </div>
</div>
